import { Controller } from "@hotwired/stimulus"

// Opens the week view's 24-hour grid scrolled to the hours that matter (the
// server picks `hour`: an hour before the week's first event) instead of at
// midnight, so a working day is on screen without scrolling.
export default class extends Controller {
    static targets = ["scroller", "body"]
    static values = { hour: { type: Number, default: 8 } }

    connect() {
        this.scrollToHour()
    }

    scrollToHour() {
        if (!this.hasScrollerTarget || !this.hasBodyTarget) return
        let hourHeight = this.bodyTarget.scrollHeight / 24
        // A few pixels short of the hour line, so its label is not clipped at the top.
        this.scrollerTarget.scrollTop = Math.max(0, Math.round(this.hourValue * hourHeight) - 10)
    }
}
